// extracted by mini-css-extract-plugin
module.exports = {"mobileHeight":"screen and (max-height: 824px)","lock":"RingLock_lock__3PfYm","ring":"RingLock_ring__14rp-"};